<ng-container *ngIf="isBusy && keyIndicatorArrays.length == 0; else show">
  <div class="key-indicator-container">
    <div class="key-indicator-item">
      <div class="label-busy loader-1 gradient"></div>
      <div class="content-busy loader-2 gradient"></div>
    </div>
  </div>
</ng-container>
<ng-template #show>
  <div *ngIf="keyIndicatorArrays.length > 0; else noItem" class="key-indicator-container">
    <div *ngFor="let keyObject of keyIndicatorArrays" class="key-indicator-item" [id]="keyObject.Name" 
    [ngStyle]="{'height' : 100 / keyIndicatorArrays.length + '%'}">
      <p class="display-label">{{keyObject.DisplayLabel}}</p>
      <div class="display-value" [ngStyle]="{'color': keyObject.DisplayColour ? keyObject.DisplayColour : '#000'}">
        {{keyObject.DisplayValue}}
      </div>
    </div>
  </div>
  <ng-template #noItem>
    <div class="no-item">
      <p>No key indicator configured</p>
    </div>
  </ng-template>
</ng-template>